// extracted by mini-css-extract-plugin
export default {"coloredImage":"ColoredImage_coloredImage__8A-x9","content":"ColoredImage_content__aBjk-","image":"ColoredImage_image__+0SKG","background":"ColoredImage_background__HfNHD"};